module.exports = __webpack_public_path__ + "img/lbl-01.85bbfd32.png";